import { Component, Input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { RequestToBidButtonComponent } from '../../../app-modules/buyer/buyer-shared/components/request-to-bid-button/request-to-bid-button.component';

@Component({
    selector: 'app-lock-category',
        standalone: true,
templateUrl: './lock-category.component.html',
    styleUrls: ['./lock-category.component.scss'],
    imports: [RequestToBidButtonComponent, TranslatePipe]
})
export class LockCategoryComponent {
  constructor() {}
  @Input() category: any;
  @Input() lockType: any;
  @Input() loggedIn: any;
  @Input() auctionSettings: any;
  @Input() horseDetails: any;
  @Input() aucType: any;
}
